interface GroundedVisualItem {
  src: string;
  alt: string;
  label: string;
  note: string;
}

interface GroundedVisualStripProps {
  eyebrow?: string;
  title: string;
  items: GroundedVisualItem[];
}

export function GroundedVisualStrip({ eyebrow, title, items }: GroundedVisualStripProps) {
  return (
    <section
      style={{
        borderRadius: "24px",
        padding: "24px",
        background: "linear-gradient(180deg, rgba(9, 14, 26, 0.92), rgba(7, 11, 21, 0.82))",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 18px 42px rgba(3, 8, 20, 0.24)"
      }}
    >
      <div className="stack-md">
        <div className="stack-xs">
          {eyebrow ? <span className="card-eyebrow">{eyebrow}</span> : null}
          <h3 className="card-title">{title}</h3>
        </div>
        <div
          style={{
            display: "grid",
            gap: "18px",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 190px), 1fr))"
          }}
        >
          {items.map((item) => (
            <figure
              key={`${item.src}-${item.label}`}
              style={{
                margin: 0,
                overflow: "hidden",
                borderRadius: "18px",
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)"
              }}
            >
              <img src={item.src} alt={item.alt} style={{ display: "block", width: "100%", height: "140px", objectFit: "cover" }} />
              <figcaption style={{ padding: "16px" }}>
                <div style={{ fontSize: "0.7rem", letterSpacing: "0.12em", textTransform: "uppercase", color: "rgba(191, 207, 229, 0.62)" }}>
                  {item.label}
                </div>
                <div style={{ marginTop: "8px", color: "rgba(232, 239, 250, 0.88)", lineHeight: 1.5 }}>{item.note}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
